module.exports = __webpack_public_path__ + "static/media/owlmov.ba973990.svg";